import { MuiFileInput, MuiFileInputProps } from 'mui-file-input'

export const FileUploader = (props: Omit<MuiFileInputProps<false>, 'contentEditable'>) => {
    return <MuiFileInput {...props} fullWidth />
}